import { Component, OnInit } from "@angular/core";
import { ScheduleService } from "./schedule.service";
import { ScheduleModel } from "./schedule.model";

@Component({
    selector: 'app-schedule-list',
    templateUrl: './schedule-list.component.html',
    standalone: false
})
export class ScheduleListComponent implements OnInit {
    schedules: ScheduleModel[] = [];

    constructor(private scheduleService: ScheduleService) { }

    ngOnInit() {
        this.scheduleService.getAll().subscribe(data => this.schedules = data);
    }

}